var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'VisualButton',
    {
      isActive: _vm.isActive,
      fitWidth: _vm.variant.width === 'fit',
      smallWidth: _vm.variant.smallWidth === 'true',
      disabled: _vm.variant.type === 'disabled',
      focus: _vm.variant.focus
    }
  ],style:({ color: _vm.variant.color }),on:{"click":function($event){_vm.variant.type === 'disabled' ? null : _vm._onClickButton($event)}}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.annotation)?_c('sup',{staticClass:"annotation"},[_vm._v("\n      "+_vm._s(_vm.annotation)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }